import { createFileRoute } from '@tanstack/react-router';
import { ManifestadorPage } from '@/features/manifestador/page/ManifestadorPage';

export const Route = createFileRoute('/a/compra/manifestador')({
    component: ManifestadorPage,
});
